import {
    IChannelComponentsWrapper,
    ILatencyWrapper,
    IProductHostsWrapper,
    ISampleRatesWrapper,
    ISupportedPlatformsWrapper,
    ISystemRequirementsWrapper,
    ITechSpecs, ITechSpecsTab, IVersionsWrapper
} from "./interfaces";
import React, {useEffect, useState} from "react";
import {rootActions, useAppDispatch, useAppSelector} from '../product-page/data-services/store';
import TabSysReq from "./tech-specs-tabs/tab-sys-req";
import {getHashByPrefix, getJSONFromHtml, getPageNodeGUID, isMobile, isTablet} from "../../../domain/common";
import TabSupportedHosts from "./tech-specs-tabs/tab-supported-hosts";
import TabSupportedPlatforms from "./tech-specs-tabs/tab-supported-platforms";
import TabChannelComponents from "./tech-specs-tabs/tab-channel-components";
import TabLatency from "./tech-specs-tabs/tab-latency";
import TabSampleRate from "./tech-specs-tabs/tab-sample-rate";
import TabTitle from "./tech-specs-tabs/tab-title";
import {ProductTypeEnum} from "../product-page/data-services/data-service";
import TabSupportedPlatformsMobile from "./tech-specs-tabs/tab-supported-platforms-mobile";
import TabChannelComponentsMobile from "./tech-specs-tabs/tab-channel-components-mobile";
import TabSampleRateLatencyMobile from "./tech-specs-tabs/tab-sample-rate-latency-mobile";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";
import TabVersion from './tech-specs-tabs/tab-versions';
import TabVersionMobile from './tech-specs-tabs/tab-versions-mobile';


export interface ITechSpecsProps {
    techSpecsProps?:ITechSpecs
}
/**
 * the entry point
 */
const TechSpecs = (props?: ITechSpecsProps) => {
    const isMobileScreen = isMobile() || isTablet();
    const productDataType = useAppSelector((store) => store.productDataType);

    const techSpecsSelectedTab = useAppSelector((store) => store.techSpecsSelectedTab);
    const techSpecsRefreshHash = useAppSelector((store) => store.techSpecsRefreshHash);
    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    const isDebugTechSpecs = useAppSelector((store) => store.isDebugTechSpecs);

    const dispatch = useAppDispatch();
    //const [selectedTab, setselectedTab] = useState<string>();
    const [systemRequirementsData, setsystemRequirementsData] = useState<ISystemRequirementsWrapper>();
    const [supportedPlatformsData, setsupportedPlatformsData] = useState<ISupportedPlatformsWrapper>();
    const [sampleRatesData, setsampleRatesData] = useState<ISampleRatesWrapper>();
    const [versionsData, setVersionsData] = useState<IVersionsWrapper>();
    const [productHostsData, setproductHostsData] = useState<IProductHostsWrapper>();
    const [latencyData, setlatencyData] = useState<ILatencyWrapper>();
    const [channelComponentsData, setchannelComponentsData] = useState<IChannelComponentsWrapper>();

    const majorVersion = getJSONFromHtml(document.getElementById('major-version')) as string
    const pageNodeGUID = getPageNodeGUID();

    //const techSpecsProps = props?.techSpecsProps;
    const tabList: ITechSpecsTab[] =
        [
            {tabID: "tab-sys-req",tabName: "System Requirements"},
            {tabID: "tab-supported-hosts",tabName: "Supported Hosts"},
            {tabID: "tab-supported-platforms",tabName: "Supported Platforms"},
            {tabID: "tab-sample-rate",tabName: "Sample Rate"},
            {tabID: "tab-channel-components",tabName: "Channel Components"},
            {tabID: "tab-latency",tabName: "Latency"},
        ];

    if(window.location.pathname.startsWith('/plugins')){
        tabList.push({tabID: "tab-versions",tabName: "Versions"},);
    }


    useEffect(() => {
        findTabFromHash();
    }, [techSpecsRefreshHash]);

    /**
     * find tab from hash
     */
    const findTabFromHash = () => {

        //console.log('0--------------------------0:',window.location.hash);
        const _mainTabHash = getHashByPrefix('tab-');
        if(_mainTabHash !== 'tab-tech-specs')
            return;
        const _tabHash = getHashByPrefix('tab-', 1);

        //console.log('----------------------------:',window.location.hash);
        //console.log('_mainTabHash:',_mainTabHash);
        //console.log('_tabHash:',_tabHash);

        if(!_tabHash || _tabHash === "")
            selectTab("tab-sys-req");


        let tab = tabList.find((t) => t.tabID === _tabHash);
        if(techSpecsRefreshHash)
        {
            tab = tabList.find((t) => t.tabID === techSpecsSelectedTab);
        }
        if(tab) {
            selectTab(tab.tabID);
            //setselectedTab(tab.tabID);
            //return tab.tabID;
        }
    };
    /**
     * find tab from hash
     */
    const getSelectedTab = (tabID :string) => {
        const tab = tabList.find((t) => t.tabID === tabID);
        return tab;
    };


    /**
     * find selected tab
     */
    const selectTab = (tadID: string) => {
        if(tadID === techSpecsSelectedTab && !techSpecsRefreshHash)
            return;
        const selectedTab = getSelectedTab(tadID);
        if(selectedTab)
            sendGAEvent('Tabs', selectedTab?.tabName);

        if(isMobileScreen)
        {
            if(!systemRequirementsData){
                let systemRequirementsWrapper = getJSONFromHtml(document.getElementById('tab-sys-req-json')) as ISystemRequirementsWrapper;
                //if(systemRequirementsWrapper && systemRequirementsWrapper.systemRequirements && systemRequirementsWrapper.systemRequirements.length > 0)
                    setsystemRequirementsData(systemRequirementsWrapper);
                //console.log('No systemRequirements:',systemRequirementsWrapper);
            }
            if(!productHostsData){
                let productHostsWrapper = getJSONFromHtml(document.getElementById('tab-supported-hosts-json')) as IProductHostsWrapper;
                //if(productHostsWrapper && productHostsWrapper.productHosts && productHostsWrapper.productHosts.length > 0)
                    setproductHostsData(productHostsWrapper);
                //console.log('No productHosts:',productHostsWrapper);
            }

            if (!versionsData) {
                let versionsWrapper = getJSONFromHtml(document.getElementById('tab-versions-json')) as IVersionsWrapper;
                setVersionsData(versionsWrapper);
            }

            if(productDataType === ProductTypeEnum.plugin) {
                if (!supportedPlatformsData) {
                    let supportedPlatformsWrapper = getJSONFromHtml(document.getElementById('tab-supported-platforms-json')) as ISupportedPlatformsWrapper;

                    //if (supportedPlatformsWrapper && supportedPlatformsWrapper.supportedPlatforms && supportedPlatformsWrapper.supportedPlatforms.length > 0)
                        setsupportedPlatformsData(supportedPlatformsWrapper);
                    //console.log('No supportedPlatforms:',supportedPlatformsWrapper);
                }
                if (!sampleRatesData) {
                    let sampleRatesWrapper = getJSONFromHtml(document.getElementById('tab-sample-rate-json')) as ISampleRatesWrapper;
                    //if (sampleRatesWrapper && sampleRatesWrapper.sampleRates && sampleRatesWrapper.sampleRates.length > 0)
                        setsampleRatesData(sampleRatesWrapper);
                    //console.log('No sampleRates:',sampleRatesWrapper);
                }



                if (!channelComponentsData) {
                    let channelComponentsWrapper = getJSONFromHtml(document.getElementById('tab-channel-components-json')) as IChannelComponentsWrapper;
                    //if (channelComponentsWrapper && channelComponentsWrapper.channelComponents && channelComponentsWrapper.channelComponents.length > 0)
                        setchannelComponentsData(channelComponentsWrapper);
                    //console.log('No channelComponents:',channelComponentsWrapper);
                }
                if (!latencyData) {
                    let latencyWrapper = getJSONFromHtml(document.getElementById('tab-latency-json')) as ILatencyWrapper;
                    //if (latencyWrapper && latencyWrapper.latency && latencyWrapper.latency.length > 0)
                        setlatencyData(latencyWrapper);
                    //console.log('No latency:',latencyWrapper);
                }
            }
        }
        else
        switch(tadID){
            default:
            case 'tab-sys-req':{
                if(!systemRequirementsData){
                    let systemRequirementsWrapper = getJSONFromHtml(document.getElementById('tab-sys-req-json')) as ISystemRequirementsWrapper;
                    //if(systemRequirementsWrapper && systemRequirementsWrapper.systemRequirements && systemRequirementsWrapper.systemRequirements.length > 0)
                        setsystemRequirementsData(systemRequirementsWrapper);
                    //console.log('No systemRequirements:',systemRequirementsWrapper);
                }
                break;
            }

            case 'tab-supported-platforms':{
                if(!supportedPlatformsData){
                    let supportedPlatformsWrapper = getJSONFromHtml(document.getElementById('tab-supported-platforms-json')) as ISupportedPlatformsWrapper;
                    //console.log('supportedPlatforms:',supportedPlatformsWrapper);
                    //if(supportedPlatformsWrapper && supportedPlatformsWrapper.supportedPlatforms && supportedPlatformsWrapper.supportedPlatforms.length > 0)
                        setsupportedPlatformsData(supportedPlatformsWrapper);
                    //console.log('No supportedPlatforms:',supportedPlatformsWrapper);
                }
                break;
            }

            case 'tab-sample-rate':{
                if(!sampleRatesData){
                    let sampleRatesWrapper = getJSONFromHtml(document.getElementById('tab-sample-rate-json')) as ISampleRatesWrapper;
                    //if(sampleRatesWrapper && sampleRatesWrapper.sampleRates && sampleRatesWrapper.sampleRates.length > 0)
                        setsampleRatesData(sampleRatesWrapper);
                    //console.log('No sampleRates:',sampleRatesWrapper);
                }
                break;
            }

            case 'tab-versions':{
                if(!versionsData){
                    let versionsWrapper = getJSONFromHtml(document.getElementById('tab-versions-json')) as IVersionsWrapper;
                    setVersionsData(versionsWrapper);
                }
                break;
            }

            case 'tab-supported-hosts':{
                if(!productHostsData){
                    let productHostsWrapper = getJSONFromHtml(document.getElementById('tab-supported-hosts-json')) as IProductHostsWrapper;
                    //if(productHostsWrapper && productHostsWrapper.productHosts && productHostsWrapper.productHosts.length > 0)
                        setproductHostsData(productHostsWrapper);
                    //console.log('No productHosts:',productHostsWrapper);
                }
                break;
            }

            case 'tab-latency':{
                if(!latencyData){
                    let latencyWrapper = getJSONFromHtml(document.getElementById('tab-latency-json')) as ILatencyWrapper;
                    //if(latencyWrapper && latencyWrapper.latency && latencyWrapper.latency.length > 0)
                        setlatencyData(latencyWrapper);
                    //console.log('No latency:',latencyWrapper);
                }
                break;
            }

            case 'tab-channel-components':{
                if(!channelComponentsData){
                    let channelComponentsWrapper = getJSONFromHtml(document.getElementById('tab-channel-components-json')) as IChannelComponentsWrapper;
                    //if(channelComponentsWrapper && channelComponentsWrapper.channelComponents && channelComponentsWrapper.channelComponents.length > 0)
                        setchannelComponentsData(channelComponentsWrapper);
                    //console.log('No channelComponents:',channelComponentsWrapper);
                }

                break;
            }

        }

        //sendGAEvent('Product Video Thumb', video.documentName)


        const _hash =  window.location.hash.substring(1);
        let _hashReplaced = "";

        const _tabHash = getHashByPrefix('tab-', 1);

        if(_tabHash && _tabHash.length > 0) {
            _hashReplaced = _hash.replace(_tabHash, tadID);
        }
        else if(_hash && _hash.length > 0)
            _hashReplaced = _hash + '|' + tadID;
        scrollToTabContent();

        dispatch(
            rootActions.main({
                techSpecsSelectedTab: tadID,
                techSpecsRefreshHash:false
            })
        );

        window.history.replaceState(null, '', document.location.pathname+ document.location.search + "#" + _hashReplaced);

    };

    const scrollToTabContent = () => {
        //const $el = document.getElementById('tech-spacs-tab-content');
        const $el = document.getElementById('sticky-place-holder');
        if(!$el) return;
        $el.scrollIntoView();
        window.scrollBy(0, 20);
    };

    const isPlugins = window.location.pathname.startsWith('/plugins');

    return (
        <div id="tech-spacs-tab-content" className="px-5 md:px-12 xl:px-0 my-4">
            <ul className="hidden lg:flex flex-row justify-center w-full menu-sticky-tech-specs">
            {
                tabList.map(tab => {
                    if(!(pageNodeGUID === 'ef493468-7253-4665-a948-9f69e14577ec' && tab.tabID === 'tab-supported-platforms'))
                    return (
                        <li key={ tab.tabID }
                            className={"mx-4 cursor-pointer " + (tab.tabID === techSpecsSelectedTab ? "border-b-2 border-gray-700" : "")}>
                            <button type="button"
                                    onClick={evt => {
                                        selectTab(tab.tabID);
                                        //menuSelect(menu);
                                    }}>{ tab.tabName }</button>
                        </li>
                    )
                    else return (<></>)
                })
            }
            </ul>
            { isDebugTechSpecs &&
                <div>
                    <div>techSpecsSelectedTab:{techSpecsSelectedTab}</div>
                    <div>techSpecsSearchPlugins:{techSpecsSearchPlugins}</div>
                    <div>isMobileScreen:{isMobileScreen.toString()}</div>
                    <div>techSpecsRefreshHash:{techSpecsRefreshHash.toString()}</div>
                </div>
            }

            {/*System Requirements*/}
                    {(isMobileScreen || techSpecsSelectedTab === 'tab-sys-req') &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle techSpecsTab={getSelectedTab('tab-sys-req')} majorVersion={majorVersion} />
                            <TabSysReq systemRequirementsWrapperProps={systemRequirementsData}/>
                        </div>
                    }

            {/*Supported Hosts*/}
                    {(isMobileScreen || techSpecsSelectedTab === 'tab-supported-hosts') &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle techSpecsTab={getSelectedTab('tab-supported-hosts')} majorVersion={majorVersion} />
                            <TabSupportedHosts productHostsWrapper={productHostsData}/>
                        </div>

                    }

            {/*Supported Platforms*/}
            {(!isMobileScreen  && techSpecsSelectedTab === 'tab-supported-platforms') &&
                <div className="waves-box-lg mx-auto px-5 md:px-12 mt-12">
                    <TabTitle techSpecsTab={getSelectedTab('tab-supported-platforms')} majorVersion={majorVersion} />
                    <TabSupportedPlatforms supportedPlatformsWrapper={supportedPlatformsData}/>
                </div>
            }
            {(isMobileScreen && productDataType === ProductTypeEnum.plugin) &&
                <div className="waves-box-lg mx-auto mt-12">
                    <TabTitle techSpecsTab={getSelectedTab('tab-supported-platforms')} majorVersion={majorVersion} />
                    <TabSupportedPlatformsMobile supportedPlatformsWrapper={supportedPlatformsData}/>
                </div>
            }

            {/*Channel Components*/}
                    {(!isMobileScreen  && techSpecsSelectedTab === 'tab-channel-components')  &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle techSpecsTab={getSelectedTab('tab-channel-components')} majorVersion={majorVersion} />
                            <TabChannelComponents channelComponentsWrapper={channelComponentsData}/>
                        </div>
                    }
                {(isMobileScreen && productDataType === ProductTypeEnum.plugin) &&
                    <div className="waves-box-lg  mx-auto mt-12">
                        <TabTitle techSpecsTab={getSelectedTab('tab-channel-components')} majorVersion={majorVersion} />
                        <TabChannelComponentsMobile channelComponentsWrapper={channelComponentsData}/>
                    </div>
                }

            {/*SampleRate + Latency*/}
                    {!isMobileScreen  && techSpecsSelectedTab === 'tab-latency' &&
                        <div className="waves-box-md mx-auto mt-12">
                            <TabTitle techSpecsTab={getSelectedTab('tab-latency')} majorVersion={majorVersion} />
                            <TabLatency latencyWrapper={latencyData}/>
                        </div>
                    }
                    {!isMobileScreen  && techSpecsSelectedTab === 'tab-sample-rate' &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle techSpecsTab={getSelectedTab('tab-sample-rate')} majorVersion={majorVersion} />
                            <TabSampleRate sampleRatesWrapper={sampleRatesData}/>
                        </div>
                    }
                    {(isMobileScreen && productDataType === ProductTypeEnum.plugin) &&
                        <div className="waves-box-lg  mx-auto mt-12">
                            <TabTitle majorVersion={majorVersion} />
                            <TabSampleRateLatencyMobile latencyWrapper={latencyData} sampleRatesWrapper={sampleRatesData}/>
                        </div>
                    }

            {
                isPlugins &&
                <>
                    {
                        !isMobileScreen && techSpecsSelectedTab === 'tab-versions' &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle
                                techSpecsTab={ getSelectedTab('tab-versions') }
                                majorVersion={ majorVersion }
                                hideVersion={ true }
                            />

                            <TabVersion versionsWrapper={ versionsData } />
                        </div>
                    }

                    {
                        isMobileScreen &&
                        <div className="waves-box-md  mx-auto mt-12">
                            <TabTitle
                                techSpecsTab={ getSelectedTab('tab-versions') }
                                majorVersion={ majorVersion }
                                hideVersion={ true }
                            />

                            <TabVersionMobile versionsWrapper={ versionsData } />
                        </div>
                    }
                </>
            }


        </div>
    )
};

export default TechSpecs;

